// @flow

import { get } from 'lodash';
import { resolve, reject } from 'redux-optimist-promise';
import createReducer from 'Store/utils/createReducer';
const FETCH_BOOKING_CHILDCARE = 'FETCH_BOOKING_CHILDCARE';
const UPDATE_CART = 'UPDATE_CART';

export const initialState = {
  data: [],
  isLoading: false,
  isLoaded: false,
  errorResponse: {},
};

export const childcareLayerReducer = createReducer(initialState, {
  [FETCH_BOOKING_CHILDCARE](state) {
    return {
      ...state,
      isLoading: true,
    };
  },
  [resolve(FETCH_BOOKING_CHILDCARE)](state, action) {
    return {
      ...state,
      isLoading: false,
      isLoaded: true,
      data: get(action, 'payload', {}),
      errorResponse: {},
    };
  },
  [reject(FETCH_BOOKING_CHILDCARE)](state, action) {
    return {
      ...state,
      isLoading: false,
      isLoaded: false,
      errorResponse: {
        errors: action.payload.errors,
      },
    };
  },
  [resolve(UPDATE_CART)](state, action) {
    return {
      ...state,
      data: {
        ...state.data,
        userBooking: {
          ...state.data.userBooking,
          ...action.payload.addServiceCart,
          ...action.payload.removeServiceCart,
        },
      },
    };
  },
  [reject(UPDATE_CART)](state, action) {
    return {
      ...state,
      errorResponse: {
        errors: action.payload.errors,
      },
    };
  },
});
